import { environment } from '~env/environment';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { CountryCode } from '~shared/constants/country-code.enum';
import { IDAMLocale, Locale } from '~shared/constants/locale.enum';

export namespace MarketDetectionUtil {
  let webAppRequest;

  export function initializeRequestFromMain(request): void{
    webAppRequest = request
  }

  export function getCountryCode(): CountryCode {
    const code = getCountryDomainCode(webAppRequest);
    return code || CountryCode.Germany;
  }

  export function isSpanishMarket() {
    return this.getCountryCode() === CountryCode.Spain;
  }

  export function isGermanMarket(): boolean {
    return this.getCountryCode() === CountryCode.Germany;
  }

  export function isItalianMarket(): boolean {
    return this.getCountryCode() === CountryCode.Italy;
  }

  export function isPortugueseMarket(): boolean {
    return this.getCountryCode() === CountryCode.Portugal;
  }

  export function isDutchMarket(): boolean {
    return this.getCountryCode() === CountryCode.Netherlands;
  }

  export function isFrenchMarket(): boolean {
    return this.getCountryCode() === CountryCode.France;
  }

  export function getLocale() {
    const countryCode = this.getCountryCode();
    return Locale[countryCode];
  }

  export function getIDAMLocale() {
    const countryCode = this.getCountryCode();
    return IDAMLocale[countryCode];
  }
}
